import { createParentCommunicatorController } from 'ui-forms-embed-components-frame-container/controllers/FormController/communicators/ParentCommunicatorController';
import { createFormCommunicatorController } from 'ui-forms-embed-components-frame-container/controllers/FormController/communicators/FormCommunicatorController';
export class FormController {
  constructor({
    applicationController
  }) {
    this.formCommunicatorController = createFormCommunicatorController({
      applicationController
    });
    this.parentCommunicatorController = createParentCommunicatorController({
      applicationController
    });
    this.initialiseFormCommunicatorControllers();
    this.initialiseParentCommunicatorControllers();
  }
  initialiseFormCommunicatorControllers() {
    const {
      sendFormReadyEvent,
      sendFormNavigationEvent,
      sendFormNavigationNextEvent,
      sendFormNavigationPreviousEvent,
      sendFormSubmissionSuccessEvent,
      sendFormSubmissionSuccessInfo,
      sendFormSubmissionFailedEvent
    } = this.parentCommunicatorController;
    this.formCommunicatorController.initialiseFormCommunicators({
      sendFormReadyEvent,
      sendFormNavigationEvent,
      sendFormNavigationNextEvent,
      sendFormNavigationPreviousEvent,
      sendFormSubmissionSuccessInfo,
      sendFormSubmissionSuccessEvent,
      sendFormSubmissionFailedEvent
    });
  }
  initialiseParentCommunicatorControllers() {
    const {
      setExtraSubmissionMetadata,
      setFieldValue
    } = this.formCommunicatorController;
    this.parentCommunicatorController.initialiseParentCommunicatorControllers({
      setExtraSubmissionMetadata,
      setFieldValue
    });
  }
}
export const createFormController = ({
  applicationController
}) => new FormController({
  applicationController
});